//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getSocialMediaSettings = createSelector(
  (state: ICuralateStore) => state.accountSettings,
  (settings) => settings.socialMedia,
);
